import React, { useState } from 'react';
import { X, HelpCircle } from 'lucide-react';
import { crearSerie } from '../servicios/api';

export default function CrearSerieNumeracion({ isOpen, onClose, onSerieCreada }) {
  const [formData, setFormData] = useState({
    nombre: '',
    tipo: 'Normal',
    mascara: ''
  });
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.nombre || !formData.mascara) {
      setError('El Nombre y la Máscara son campos obligatorios.');
      return;
    }
    setError('');
    try {
      const response = await crearSerie(formData);
      if (response.exito) {
        alert(response.mensaje || 'Serie creada con éxito.');
        if (onSerieCreada) {
          onSerieCreada(response.serie);
        }
        onClose(); // Cierra el modal en éxito
      } else {
        setError(response.mensaje || 'Ocurrió un error desconocido.');
      }
    } catch (err) {
      console.error("Error al crear la serie:", err);
      const errorMessage = err.response?.data?.mensaje || 'Error al conectar con el servidor.';
      setError(errorMessage);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-50">
      <div className="bg-slate-900 rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col overflow-hidden border border-slate-700">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-slate-700 bg-slate-800">
          <h2 className="text-lg font-semibold text-white">
            Crear nueva serie de numeración
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            <X size={24} />
          </button>
        </div>

        {/* Form Content */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4 overflow-y-auto">
          {/* Nombre */}
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Nombre
            </label>
            <input
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-slate-700 rounded-md bg-slate-800 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Tipo */}
          <div className="flex items-center gap-2">
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-300 mb-1">
                Tipo
              </label>
              <select
                name="tipo"
                value={formData.tipo}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-slate-700 rounded-md bg-slate-800 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="Normal">Normal</option>
                <option value="Secuencial">Secuencial</option>
                <option value="Por fecha">Por fecha</option>
              </select>
            </div>
            <div className="mt-6">
              <HelpCircle size={20} className="text-gray-400" />
            </div>
          </div>

          {/* Máscara */}
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">
              Máscara
            </label>
            <input
              type="text"
              name="mascara"
              value={formData.mascara}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-slate-700 rounded-md bg-slate-800 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Instrucciones */}
          <div className="bg-slate-800 border border-slate-700 rounded-md p-4">
            <h3 className="font-semibold text-blue-400 mb-2">Instrucciones</h3>
            <p className="text-sm text-gray-400 mb-3">
              Debes escribir una máscara de numeración que será interpretada para sugerir el siguiente número de factura.
            </p>
            <p className="text-sm text-gray-400 mb-3">
              La máscara puede estar compuesta por cualquiera de los siguientes caracteres:
            </p>

            <ul className="text-sm text-gray-400 space-y-2 mb-3">
              <li><code className="bg-slate-700 px-1 rounded">AAAA</code> será sustituido por el año en formato de cuatro dígitos.</li>
              <li><code className="bg-slate-700 px-1 rounded">AA</code> será sustituido por el año en formato de dos dígitos.</li>
              <li><code className="bg-slate-700 px-1 rounded">#</code> será sustituido por un número incremental.</li>
              <li>Cualquier otro carácter se mantendrá.</li>
            </ul>

            <div className="text-sm text-gray-400">
              <p className="font-semibold text-white mb-1">Ejemplo:</p>
              <ul className="space-y-1">
                <li><code className="bg-slate-700 px-1 rounded">CS-AAAA-####</code> generaría: CS-2025-0001...</li>
                <li><code className="bg-slate-700 px-1 rounded">F-AA-###</code> generaría: F-25-001...</li>
              </ul>
            </div>
          </div>

          {error && <p className="text-red-500 text-sm my-2 text-center">{error}</p>}
        </form>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-4 border-t border-slate-700 bg-slate-800">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-300 bg-slate-600 border border-transparent rounded-md hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Cerrar
          </button>
          <button
            type="submit"
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
}